import { Skeleton } from 'antd'
import React, { FunctionComponent, Suspense, useMemo } from 'react'

import { TABLE_VIEW } from '../../../common/foreclosureMonitoringTypes'
import { monitoringTilesStyle } from '../../utils/layoutConst'
import { defaultViewParam } from '../../utils/paths'
import { monitoringViewSlug } from '../../utils/tabsHelpers'
import { useTabKeyState } from '../../utils/useTabKeyState'
import { TableSkeleton } from '../TableSkeleton/TableSkeleton'

export interface MonitoringContentSuspenseProps {
  children: React.ReactNode
}

const tilesCount = 10
const NodeStyle = { width: '100%', height: '300px' }

export const MonitoringContentSuspense: FunctionComponent<MonitoringContentSuspenseProps> =
  ({ children }) => {
    const [viewType] = useTabKeyState<TABLE_VIEW>(
      TABLE_VIEW.TABLE,
      monitoringViewSlug,
      defaultViewParam
    )

    const tilesFallback = useMemo(
      () => (
        <div className={monitoringTilesStyle}>
          {Array.from({ length: tilesCount }).map((_, i) => (
            <Skeleton.Node key={i} active style={NodeStyle} />
          ))}
        </div>
      ),
      []
    )

    const fallback = useMemo(
      () => (viewType === TABLE_VIEW.TILES ? tilesFallback : <TableSkeleton />),
      [tilesFallback, viewType]
    )

    return <Suspense fallback={fallback}>{children}</Suspense>
  }
